import { useMatchMedia } from '../../hooks/useMatchMedia'
import { pageBreakpoints } from '../../config/pageBreakpoints'
import { ReactElement } from 'react'
import { MobileDatenschutzScreen } from './MobileDatenschutzScreen'
import { WebDatenschutzScreen } from './WebDatenschutzScreen'

export const DatenschutzScreen = (): ReactElement => {
  const isMobile = useMatchMedia(`(max-width:${pageBreakpoints.md})`)

  return isMobile ? <MobileDatenschutzScreen /> : <WebDatenschutzScreen />
}
